import React, { useEffect, useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { AlertTriangleIcon, CheckIcon, XIcon, SearchIcon, FilterIcon, CalendarIcon, ClockIcon, MapPinIcon, UsersIcon, MessageSquareIcon, PhoneIcon, EditIcon, ChevronDownIcon, ChevronUpIcon, CheckSquareIcon, SaveIcon } from 'lucide-react';
// Mock data for trainings
const mockTrainings = [{
  id: 1,
  date: new Date(),
  startTime: new Date(new Date().setHours(9, 0)),
  endTime: new Date(new Date().setHours(12, 0)),
  type: 'Sliptraining Basis',
  location: 'Rotterdam',
  address: 'Slipbaanweg 10, 3045 Rotterdam',
  client: 'Gemeente Rotterdam',
  participants: [{
    id: 1,
    name: 'Jan Janssen',
    email: 'j.janssen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 2,
    name: 'Piet Pietersen',
    email: 'p.pietersen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 3,
    name: 'Klaas Klaassen',
    email: 'k.klaassen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 4,
    name: 'Henk Hendriks',
    email: 'h.hendriks@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 5,
    name: 'Sjaak Sjaaksen',
    email: 's.sjaaksen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 6,
    name: 'Willem Willemsen',
    email: 'w.willemsen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }],
  status: 'ongoing',
  notes: ''
}, {
  id: 2,
  date: new Date(),
  startTime: new Date(new Date().setHours(13, 30)),
  endTime: new Date(new Date().setHours(16, 30)),
  type: 'Defensief Rijden',
  location: 'Utrecht',
  address: 'Defensieweg 5, 3584 Utrecht',
  client: 'ProRail',
  participants: [{
    id: 7,
    name: 'Anna Bakker',
    email: 'a.bakker@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 8,
    name: 'Peter Post',
    email: 'p.post@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 9,
    name: 'Maria Visser',
    email: 'm.visser@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 10,
    name: 'Thomas Berg',
    email: 't.berg@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }],
  status: 'upcoming',
  notes: ''
}, {
  id: 3,
  date: new Date(new Date().setDate(new Date().getDate() - 1)),
  startTime: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(10, 0),
  endTime: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(13, 0),
  type: 'Code 95 Training',
  location: 'Amsterdam',
  address: 'Transportweg 8, 1043 Amsterdam',
  client: 'Transport BV',
  participants: [{
    id: 16,
    name: 'Hans Hansen',
    email: 'h.hansen@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 17,
    name: 'Petra Peters',
    email: 'p.peters@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 18,
    name: 'Johan Johanssen',
    email: 'j.johanssen@transport.nl',
    company: 'Transport BV',
    present: false,
    notes: 'Ziek gemeld'
  }, {
    id: 19,
    name: 'Bart Bartels',
    email: 'b.bartels@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 20,
    name: 'Gerrit Gerrits',
    email: 'g.gerrits@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 21,
    name: 'Dirk Dirksen',
    email: 'd.dirksen@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 22,
    name: 'Karel Karels',
    email: 'k.karels@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }],
  status: 'completed',
  notes: 'Training is goed verlopen. Deelnemers waren enthousiast over de praktijkoefeningen.'
}];
// Helper function to format time
const formatTime = date => {
  return date.toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit'
  });
};
// Helper function to format date
const formatDate = date => {
  return date.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
};
export function AttendanceRegistration() {
  const [trainings, setTrainings] = useState(mockTrainings);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('today');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  // Filter trainings based on date filter
  const filteredTrainings = trainings.filter(training => {
    const trainingDate = new Date(training.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (dateFilter === 'today') {
      return trainingDate.toDateString() === today.toDateString();
    } else if (dateFilter === 'tomorrow') {
      return trainingDate.toDateString() === tomorrow.toDateString();
    } else if (dateFilter === 'all') {
      return true;
    } else if (dateFilter === 'past') {
      return trainingDate < today;
    } else if (dateFilter === 'upcoming') {
      return trainingDate >= today;
    }
    return true;
  }).filter(training => {
    // Also filter by search term if provided
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      return training.type.toLowerCase().includes(searchLower) || training.location.toLowerCase().includes(searchLower) || training.client.toLowerCase().includes(searchLower);
    }
    return true;
  });
  // Handle training selection
  const handleSelectTraining = training => {
    setSelectedTraining(training);
  };
  // Handle attendance change
  const handleAttendanceChange = (participantId, present) => {
    if (!selectedTraining) return;
    const updatedTraining = {
      ...selectedTraining,
      participants: selectedTraining.participants.map(participant => {
        if (participant.id === participantId) {
          return {
            ...participant,
            present
          };
        }
        return participant;
      })
    };
    setSelectedTraining(updatedTraining);
    // Also update the training in the full list
    setTrainings(trainings.map(training => {
      if (training.id === selectedTraining.id) {
        return updatedTraining;
      }
      return training;
    }));
  };
  // Handle participant note change
  const handleNoteChange = (participantId, notes) => {
    if (!selectedTraining) return;
    const updatedTraining = {
      ...selectedTraining,
      participants: selectedTraining.participants.map(participant => {
        if (participant.id === participantId) {
          return {
            ...participant,
            notes
          };
        }
        return participant;
      })
    };
    setSelectedTraining(updatedTraining);
    // Also update the training in the full list
    setTrainings(trainings.map(training => {
      if (training.id === selectedTraining.id) {
        return updatedTraining;
      }
      return training;
    }));
  };
  // Handle training notes change
  const handleTrainingNotesChange = notes => {
    if (!selectedTraining) return;
    const updatedTraining = {
      ...selectedTraining,
      notes
    };
    setSelectedTraining(updatedTraining);
    // Also update the training in the full list
    setTrainings(trainings.map(training => {
      if (training.id === selectedTraining.id) {
        return updatedTraining;
      }
      return training;
    }));
  };
  // Handle save attendance
  const handleSaveAttendance = () => {
    // In a real app, this would save the data to the server
    // Mark training as completed if it was ongoing
    if (selectedTraining.status === 'ongoing') {
      const updatedTraining = {
        ...selectedTraining,
        status: 'completed'
      };
      setSelectedTraining(updatedTraining);
      // Also update the training in the full list
      setTrainings(trainings.map(training => {
        if (training.id === selectedTraining.id) {
          return updatedTraining;
        }
        return training;
      }));
    }
    // Show success message
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };
  // Calculate attendance statistics
  const getAttendanceStats = () => {
    if (!selectedTraining) return {
      total: 0,
      present: 0,
      absent: 0,
      unknown: 0
    };
    const total = selectedTraining.participants.length;
    const present = selectedTraining.participants.filter(p => p.present === true).length;
    const absent = selectedTraining.participants.filter(p => p.present === false).length;
    const unknown = total - present - absent;
    return {
      total,
      present,
      absent,
      unknown
    };
  };
  // Get badge color based on training status
  const getStatusBadge = status => {
    switch (status) {
      case 'completed':
        return <Badge variant="success" data-id="element-1086">Afgerond</Badge>;
      case 'ongoing':
        return <Badge variant="info" data-id="element-1087">Bezig</Badge>;
      case 'upcoming':
        return <Badge variant="warning" data-id="element-1088">Gepland</Badge>;
      default:
        return <Badge variant="default" data-id="element-1089">Onbekend</Badge>;
    }
  };
  return <div className="space-y-6" data-id="element-1090">
      <div className="flex justify-between items-center" data-id="element-1091">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1092">
          Aanwezigheid Registreren
        </h1>
        <div className="flex space-x-2" data-id="element-1093">
          <select value={dateFilter} onChange={e => setDateFilter(e.target.value)} className="bg-white border border-gray-300 text-gray-700 py-2 px-3 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#B61C1C]" data-id="element-1094">
            <option value="today" data-id="element-1095">Vandaag</option>
            <option value="tomorrow" data-id="element-1096">Morgen</option>
            <option value="upcoming" data-id="element-1097">Aankomend</option>
            <option value="past" data-id="element-1098">Afgerond</option>
            <option value="all" data-id="element-1099">Alle trainingen</option>
          </select>
        </div>
      </div>
      {/* Success message */}
      {showSuccessMessage && <div className="fixed top-4 right-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded z-50 shadow-md flex items-center" data-id="element-1100">
          <CheckIcon className="h-5 w-5 mr-2" data-id="element-1101" />
          <span data-id="element-1102">Aanwezigheid succesvol opgeslagen</span>
        </div>}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1103">
        {/* Trainings list */}
        <div className="lg:col-span-1" data-id="element-1104">
          <Card data-id="element-1105">
            <div className="p-4 border-b border-gray-200" data-id="element-1106">
              <div className="relative" data-id="element-1107">
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1108" />
                <input type="text" placeholder="Zoek trainingen..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#B61C1C]" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1109" />
              </div>
            </div>
            <div className="p-4 max-h-[600px] overflow-y-auto" data-id="element-1110">
              {filteredTrainings.length > 0 ? <div className="space-y-3" data-id="element-1111">
                  {filteredTrainings.map(training => <div key={training.id} className={`p-3 rounded-md border cursor-pointer transition-colors ${selectedTraining?.id === training.id ? 'bg-gray-100 border-[#B61C1C]' : 'bg-white border-gray-200 hover:bg-gray-50'}`} onClick={() => handleSelectTraining(training)} data-id="element-1112">
                      <div className="flex justify-between items-start" data-id="element-1113">
                        <div data-id="element-1114">
                          <h3 className="font-medium text-gray-900" data-id="element-1115">
                            {training.type}
                          </h3>
                          <p className="text-sm text-gray-500" data-id="element-1116">
                            {training.client}
                          </p>
                          <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-1117">
                            <CalendarIcon size={12} className="mr-1" data-id="element-1118" />
                            <span data-id="element-1119">{formatDate(new Date(training.date))}</span>
                          </div>
                          <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-1120">
                            <ClockIcon size={12} className="mr-1" data-id="element-1121" />
                            <span data-id="element-1122">
                              {formatTime(new Date(training.startTime))} -{' '}
                              {formatTime(new Date(training.endTime))}
                            </span>
                          </div>
                          <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-1123">
                            <MapPinIcon size={12} className="mr-1" data-id="element-1124" />
                            <span data-id="element-1125">{training.location}</span>
                          </div>
                        </div>
                        <div data-id="element-1126">
                          {getStatusBadge(training.status)}
                          <div className="mt-2 text-xs text-gray-500" data-id="element-1127">
                            <UsersIcon size={12} className="inline mr-1" data-id="element-1128" />
                            <span data-id="element-1129">
                              {training.participants.length} deelnemers
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div> : <div className="text-center py-6" data-id="element-1130">
                  <CalendarIcon className="h-12 w-12 text-gray-300 mx-auto mb-2" data-id="element-1131" />
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-1132">
                    Geen trainingen gevonden
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-1133">
                    Pas je filters aan om trainingen te vinden
                  </p>
                </div>}
            </div>
          </Card>
        </div>
        {/* Attendance registration */}
        <div className="lg:col-span-2" data-id="element-1134">
          {selectedTraining ? <Card data-id="element-1135">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1136">
                <div data-id="element-1137">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-1138">
                    {selectedTraining.type}
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1139">
                    {selectedTraining.client} |{' '}
                    {formatDate(new Date(selectedTraining.date))}
                  </p>
                </div>
                <div className="flex space-x-2" data-id="element-1140">
                  {getStatusBadge(selectedTraining.status)}
                </div>
              </div>
              <div className="p-4" data-id="element-1141">
                <div className="mb-4 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1142">
                  <div className="bg-blue-50 p-3 rounded-md" data-id="element-1143">
                    <div className="text-xs text-blue-500 font-medium" data-id="element-1144">
                      Totaal
                    </div>
                    <div className="text-2xl font-bold text-blue-700" data-id="element-1145">
                      {getAttendanceStats().total}
                    </div>
                  </div>
                  <div className="bg-green-50 p-3 rounded-md" data-id="element-1146">
                    <div className="text-xs text-green-500 font-medium" data-id="element-1147">
                      Aanwezig
                    </div>
                    <div className="text-2xl font-bold text-green-700" data-id="element-1148">
                      {getAttendanceStats().present}
                    </div>
                  </div>
                  <div className="bg-red-50 p-3 rounded-md" data-id="element-1149">
                    <div className="text-xs text-red-500 font-medium" data-id="element-1150">
                      Afwezig
                    </div>
                    <div className="text-2xl font-bold text-red-700" data-id="element-1151">
                      {getAttendanceStats().absent}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-md" data-id="element-1152">
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1153">
                      Onbekend
                    </div>
                    <div className="text-2xl font-bold text-gray-700" data-id="element-1154">
                      {getAttendanceStats().unknown}
                    </div>
                  </div>
                </div>
                <div className="mb-4" data-id="element-1155">
                  <div className="bg-white border border-gray-200 rounded-md overflow-hidden" data-id="element-1156">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-1157">
                      <thead className="bg-gray-50" data-id="element-1158">
                        <tr data-id="element-1159">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1160">
                            Deelnemer
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1161">
                            Bedrijf
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1162">
                            Aanwezig
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1163">
                            Notities
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-1164">
                        {selectedTraining.participants.map(participant => <tr key={participant.id} data-id="element-1165">
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-1166">
                              <div className="text-sm font-medium text-gray-900" data-id="element-1167">
                                {participant.name}
                              </div>
                              <div className="text-xs text-gray-500" data-id="element-1168">
                                {participant.email}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1169">
                              {participant.company}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-1170">
                              <div className="flex space-x-2" data-id="element-1171">
                                <button className={`p-1 rounded ${participant.present === true ? 'bg-green-100 text-green-800 ring-2 ring-green-500' : 'bg-gray-100 text-gray-800 hover:bg-green-50'}`} onClick={() => handleAttendanceChange(participant.id, true)} disabled={selectedTraining.status === 'completed'} data-id="element-1172">
                                  <CheckIcon size={16} data-id="element-1173" />
                                </button>
                                <button className={`p-1 rounded ${participant.present === false ? 'bg-red-100 text-red-800 ring-2 ring-red-500' : 'bg-gray-100 text-gray-800 hover:bg-red-50'}`} onClick={() => handleAttendanceChange(participant.id, false)} disabled={selectedTraining.status === 'completed'} data-id="element-1174">
                                  <XIcon size={16} data-id="element-1175" />
                                </button>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-1176">
                              <input type="text" className="w-full p-1 text-sm border border-gray-300 rounded" placeholder="Notitie..." value={participant.notes || ''} onChange={e => handleNoteChange(participant.id, e.target.value)} disabled={selectedTraining.status === 'completed'} data-id="element-1177" />
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="mb-4" data-id="element-1178">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1179">
                    Algemene opmerkingen
                  </label>
                  <textarea className="w-full p-2 border border-gray-300 rounded-md" rows={3} placeholder="Voeg hier algemene opmerkingen toe over de training..." value={selectedTraining.notes} onChange={e => handleTrainingNotesChange(e.target.value)} disabled={selectedTraining.status === 'completed'} data-id="element-1180"></textarea>
                </div>
                <div className="flex justify-end" data-id="element-1181">
                  {selectedTraining.status !== 'completed' && <Button variant="primary" onClick={handleSaveAttendance} disabled={getAttendanceStats().unknown > 0} data-id="element-1182">
                      <SaveIcon size={16} className="mr-1" data-id="element-1183" />
                      Aanwezigheid Opslaan
                    </Button>}
                  {selectedTraining.status === 'completed' && <Button variant="outline" disabled data-id="element-1184">
                      <CheckIcon size={16} className="mr-1" data-id="element-1185" />
                      Aanwezigheid Geregistreerd
                    </Button>}
                </div>
              </div>
            </Card> : <Card data-id="element-1186">
              <div className="p-6 text-center" data-id="element-1187">
                <CheckSquareIcon className="h-12 w-12 text-gray-300 mx-auto mb-2" data-id="element-1188" />
                <h3 className="text-lg font-medium text-gray-900" data-id="element-1189">
                  Geen training geselecteerd
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1190">
                  Selecteer een training om aanwezigheid te registreren
                </p>
              </div>
            </Card>}
        </div>
      </div>
    </div>;
}